import axios from "axios";
import API from "../helpers/api";
import swal from "sweetalert";
let searchData = {
    Name: '',
    PageNumber: 1,
    PageSize: 25
}
let user = JSON.parse(localStorage.getItem("currentUser"));
export const getStaffInfo = (item) => {
    let url = `${API.SearchStaff}?Name=${item.Name}&PageNumber=${item.PageNumber}&PageSize=${item.PageSize}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getStaffInfoListSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getStaffInfoListFailure",
                    error: "ERROR"
                })
            })
    }
}
export const postStaffInfoList = (data) => {
    let url = `${API.PostStaff}`;
    return dispatch => {
        axios.post(url, data, {
            headers: {
                key: user.accessToken,
            }
        })
            .then((response) => {
                dispatch(getStaffInfo(searchData));
                dispatch({
                    type: "postStaffInfoSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                swal("Error!", "Something went wrong. Please try again.", "warning");
                dispatch({
                    type: "postStaffInfoFailure",
                    error: "ERROR"
                })
            })
    }
}
export const putStaffInfoList = (data) => {
    let url = `${API.PostStaff}`;
    return dispatch => {
        axios.put(url, data, {
            headers: {
                key: user.accessToken,
            }
        })
            .then((response) => {
                dispatch(getStaffInfo(searchData));
                dispatch({
                    type: "updateStaffInfoSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                swal("Error!", "Something went wrong. Please try again.", "warning");
                dispatch({
                    type: "updateStaffInfoFailure",
                    error: "ERROR"
                })
            })
    }
}
export const deleteStaffInfoList = (data) => {
    let url = `${API.PostStaff}`;
    return dispatch => {
        axios.put(url, data, {
            headers: {
                key: user.accessToken,
            }
        })
            .then((response) => {
                dispatch(getStaffInfo(searchData));
                dispatch({
                    type: "deleteStaffInfoSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                swal("Error!", `${error.message}`, "warning");
                dispatch({
                    type: "deleteStaffInfoFailure",
                    error: "ERROR"
                })
            })
    }
}

